import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivityFilterScreen } from '@gripp/shared-ui';

interface ActivityFilterModalProps {
  isVisible: boolean;
  onDismiss: () => void;
  filterKey?: ActivityFilterKey;
}

export const ActivityFilterModal = ({
  isVisible,
  onDismiss,
  filterKey = ActivityFilterKey.Activity,
}: ActivityFilterModalProps) => (
  <ActivityFilterScreen
    mode="modal"
    isVisible={isVisible}
    onDismiss={onDismiss}
    filterKey={filterKey}
  />
);
